import React from "react";

export class MetaTags extends React.Component {
    constructor(props) {
        super(props);
    }


    componentDidMount() {
        this._title = document.querySelector('title').getAttribute("data-org");
        this._description = document.querySelector('meta[name="description"]').getAttribute("content");
        this._url = document.querySelector('meta[property="og:url"]').getAttribute("content");
        this._image = document.querySelector('meta[property="og:image"]').getAttribute("content");

        document.querySelector('title').innerText = this.props.title || this._title;
        document.querySelector('meta[name="description"]').setAttribute("content", this.props.description || this._description);
        document.querySelector('meta[property="og:title"]').setAttribute("content", this.props.title || this._title);
        document.querySelector('meta[property="og:description"]').setAttribute("content", this.props.description || this._description);
        document.querySelector('meta[property="og:url"]').setAttribute("content", window.location.href || this._url);
        document.querySelector('meta[property="og:image"]').setAttribute("content", this.props.image || this._image);

    }



    componentWillUnmount() {
        document.querySelector('title').innerText = this._title;
        document.querySelector('meta[name="description"]').setAttribute("content", this._description);
        document.querySelector('meta[property="og:title"]').setAttribute("content", this._title);
        document.querySelector('meta[property="og:description"]').setAttribute("content", this._description);
        document.querySelector('meta[property="og:url"]').setAttribute("content", this._url);
        document.querySelector('meta[property="og:image"]').setAttribute("content", this._image);
    }

    render() {
        return null;
    }

};
